import React, {Component} from 'react'
import { Videos } from './../../../components'
import { withLoader } from '../../../hoc/withLoader'
import { TrainingStyle } from '../../../styles'

class Training extends Component {
  componentDidMount () {
    document.body.classList.add('nofooter')
  }

  componentWillUnmount () {
    document.body.classList.remove('nofooter')
  }
  render () {
    const {data} = this.props
    return (
      <div className={`training ${TrainingStyle}`}>
        {
          data && data.summary.map((panel, index) => (
            panel.type === 'videos' && (
              <Videos title={panel.title} groups={panel.fields.groups} picture={panel.picture} key={index} />
            )
          ))
        }
      </div>
    )
  }
}

export default withLoader(Training)


// WEBPACK FOOTER //
// ./src/scenes/Pages/container/Training.js